// extracted by mini-css-extract-plugin
export var gradient = "SliderItem-module--gradient--8da13";
export var hasNoImage = "SliderItem-module--hasNoImage--c84b4";
export var hasNoLabel = "SliderItem-module--hasNoLabel--6777e";
export var item = "SliderItem-module--item--53610";
export var label = "SliderItem-module--label--3ecdf";
export var picture = "SliderItem-module--picture--5d121";